import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import LazyBackgroundImage from "../LazyBackgroundImage";

import "yet-another-react-lightbox/styles.css";
import "./index.css";

/* Stills (lightbox posters) and film posters (cards) - Using optimized images */
import aboutMyFatherPoster from "./img/ABOUTMYFATHER_STILL-min.jpg";
import fitsAndStartsPoster from "./img/FITSANDSTARTS_STILL-min.jpg";
import goodGirlsGetHighPoster from "./img/GOODGIRLS_STILL-min.jpg";
import helloMyNameIsDorisPoster from "./img/HELLOMYNAMEISDORIS_STILL-min.jpg";
import workItPoster from "./img/WORKITTRAILER-min.jpg";

import aboutMyFather from "./img/about_my_father-min.jpg";
import workIt from "./img/work_it-min.jpg";
import goodGirlsGetHigh from "./img/good_girls_get_high-min.jpg";
import helloMyNameIsDoris from "./img/hello_my_name_is_doris-min.jpg";
import fitsAndStarts from "./img/fits_and_starts-min.jpg";
import dickenson from "./img/dickenson-min.jpg";

// Cloudflare R2 CDN URL for videos
const R2_CDN_URL = "https://pub-7648986858144089bb11c4e181a49aba.r2.dev";

/* Card display order; films without a trailer render disabled.
   Exported for tests: card index i must line up with slides[i]. */
export const films = [
  {
    title: "About My Father",
    image: aboutMyFather,
    role: "Director",
    meta: "Lionsgate / 2023",
    poster: aboutMyFatherPoster,
    // Chrome skips <source type="video/quicktime"> entirely; the files are
    // H.264/AAC so labeling them video/mp4 lets every browser play them.
    trailer: { src: `${R2_CDN_URL}/ABOUTMYFATHERTRAILER.mov`, type: "video/mp4" },
  },
  {
    title: "Work It",
    image: workIt,
    role: "Director",
    meta: "Netflix / 2020",
    poster: workItPoster,
    trailer: { src: `${R2_CDN_URL}/WORKITTRAILER.mov`, type: "video/mp4" },
  },
  {
    title: "Good Girls Get High",
    image: goodGirlsGetHigh,
    role: "Writer / Director",
    meta: "Warner Blue Ribbon / 2019",
    poster: goodGirlsGetHighPoster,
    trailer: { src: `${R2_CDN_URL}/GoodGirlsTrailerTrimmed.mp4`, type: "video/mp4" },
  },
  {
    title: "Hello, My Name is Doris",
    image: helloMyNameIsDoris,
    role: "Writer / Co-Producer",
    meta: "Roadside Attractions / 2016",
    poster: helloMyNameIsDorisPoster,
    trailer: { src: `${R2_CDN_URL}/HELLOMYNAMEISDORISTRAILER.mp4`, type: "video/mp4" },
  },
  {
    title: "Fits and Starts",
    image: fitsAndStarts,
    role: "Writer / Director / Producer",
    meta: "The Orchard / 2017",
    poster: fitsAndStartsPoster,
    trailer: { src: `${R2_CDN_URL}/FITSANDSTARTSTRAILER.mp4`, type: "video/mp4" },
  },
  {
    title: "Dickinson",
    image: dickenson,
    role: "Director",
    meta: "Apple / 2021",
  },
];

export const slides = films
  .filter((film) => film.trailer)
  .map((film) => ({
    title: film.title,
    poster: film.poster,
    sources: [film.trailer],
    type: "video",
  }));

const Filmography = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <section id="trailers" className="section-styles-table">
      <h1 className="filmography-header">Trailers</h1>
      <div className="section-row">
        {films.map((film, i) => (
          <div className="section-col" key={film.title}>
            <button
              className={`trailer-card__wrapper${film.trailer ? "" : " disabled"}`}
              disabled={!film.trailer}
              onClick={() => {
                setIndex(i);
                setOpen(true);
              }}
            >
              <figure className="column__item">
                <div className="column__item-imgwrap" data-pos="2">
                  <LazyBackgroundImage
                    src={film.image}
                    className="column__item-img"
                    optWidth={640}
                  />
                </div>
                <figcaption className="column__item-caption">
                  <p className="caption-role">{film.role}</p>
                  <p className="caption-meta">{film.meta}</p>
                </figcaption>
              </figure>
            </button>
          </div>
        ))}
      </div>
      <Lightbox
        close={() => setOpen(false)}
        index={index}
        open={open}
        plugins={[Video]}
        slides={slides}
      />
    </section>
  );
};

export default Filmography;
